import axios from '../api';

const inFlightRequests = new Map();

async function deduplicateRequest(key, requestFn) {
  if (inFlightRequests.has(key)) {
    return inFlightRequests.get(key);
  }

  const promise = requestFn();

  inFlightRequests.set(key, promise);

  promise.finally(() => {
    inFlightRequests.delete(key);
  });

  return promise;
}

export const checkAuth = async () => {
  return deduplicateRequest('checkAuth', async () => {
    try {
      const res = await axios.get('/api/auth/check');
      return res.data;
    } catch (error) {
      console.error('Error checking auth:', error);
      return null;
    }
  });
};
